import { Cookie } from '../components/cookie';
import { Modal } from '../components/modal';
import { addPrivacy } from './add_privacy';

export function cookiesNotice() {
    const cookie = new Cookie;
    const modal = new Modal;

    function cookiesNoticeShow() {
        if (cookie.get('cookiesNoticeShown') || (!cookie.get('isCityCorrect') && window.innerWidth < 768) ) {
            return false;
        }

        const block = document.createElement('div');
        const layout = `Для улучшения работы сайта мы используем файлы cookie.
                        Продолжая работу с сайтом, Вы разрешаете использование cookie-файлов.
                        Вы всегда можете отключить файлы cookie в настройках Вашего браузера.
                        Подробнее в <a href="javascript:void(0)" data-open="privacy" am-link="cookies_notice" class="js-addPrivacy">Политике конфиденциальности</a> и
                        <a href="javascript:void(0)" data-open="agreement" am-link="cookies_notice" class="js-addAgreement">Условиях использования сайта</a>
                        <div am-close="cookies_notice"></div>`;

        block.setAttribute('am-block', 'cookies_notice');
        block.innerHTML = layout;
        document.body.appendChild(block);

        const close = document.querySelector('[am-close="cookies_notice"]');
        close.addEventListener('click', function() {
            this.parentNode.remove();
            cookie.set('cookiesNoticeShown', 1, {domain: 'xn--e1aglvb.xn--p1ai'});
        });

        modal.init('open', 'modal', 'close');
        addPrivacy();
    }

    cookiesNoticeShow();

    window.cookiesNoticeShow = cookiesNoticeShow;
}

